import React from 'react';
import styled, { css } from 'styled-components';
import AnimateHeight from 'react-animate-height';
import PropTypes from 'prop-types';
import { fontFamilyBody } from '../styles/helpers/mixins';
import { color, size, animation } from '../styles/helpers/variables';

const AccordionItemWithText = props => {
  const { index, isActive, isLastItem, children, title, setActive, number, darkTheme } = props;
  return (
    <AccordionItemContainer darkTheme={darkTheme} active={isActive} lastItem={isLastItem}>
      <AccordionItemButton
        darkTheme={darkTheme}
        active={isActive}
        lastItem={isLastItem}
        onClick={() => setActive(index)}
      >
        <AccordionItemTitle>
          {title}
          {number > 0 && <Number>{number}</Number>}
        </AccordionItemTitle>
      </AccordionItemButton>
      <AnimateHeight className="animation" duration={250} easing="ease-out" height={isActive ? 'auto' : 0}>
        {children}
      </AnimateHeight>
    </AccordionItemContainer>
  );
};

const AccordionItemContainer = styled.div`
  width: 100%;
  font-weight: 600;
`;

const Number = styled.span`
  color: ${color.primary};

  &:before {
    content: ' (';
    color: ${color.black};
  }

  &:after {
    content: ')';
    color: ${color.black};
  }
`;

const AccordionItemTitle = styled.p`
  flex: 1;
  padding: 0 14px 0 0;
  margin: 18px 0;
  font-size: 12px;
  font-weight: 600 !important;
`;

const AccordionItemButton = styled.button`
  ${fontFamilyBody};
  width: 100%;
  padding: 0 1rem 0 0;
  outline: 0;
  cursor: pointer;
  border: ${props => props.theme.border};
  border-left: 0;
  border-right: 0;
  background-color: transparent;
  border-bottom: none;

  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2px;
  text-align: left;
  color: ${props => props.theme.fg};
  text-transform: uppercase;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  &:after {
    content: '';
    background-image: ${props => props.theme.arrow};
    background-size: contain;
    background-repeat: no-repeat;
    min-width: 12px;
    height: 12px;
    justify-self: flex-end;
    display: block;
    margin-left: 10px;
    transition: transform ${animation.transitionTime} ${animation.easing};
    ${props =>
      props.active &&
      css`
        transform: rotateX(180deg);
      `};
  }

  ${props =>
    props.active &&
    css`
      border-bottom: none;
    `};

  @media screen and (min-width: ${size.large}px) {
    font-size: 13px;
  }
`;

AccordionItemWithText.defaultProps = {
  number: 0,
  isActive: false,
  isLastItem: false,
  darkTheme: false,
  title: '',
  index: null,
  setActive: () => {}
};

AccordionItemWithText.propTypes = {
  number: PropTypes.number,
  index: PropTypes.number,
  isActive: PropTypes.bool,
  isLastItem: PropTypes.bool,
  darkTheme: PropTypes.bool,
  title: PropTypes.string,
  setActive: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default AccordionItemWithText;



// WEBPACK FOOTER //
// ./src/components/AccordionItemWithText.js